export class Autorizacao {
    constructor(
        public podeAcessar: boolean,
        public podeIncluir: boolean,
        public podeExcluir: boolean,
        public podeAlterar: boolean,
        public podeListar: boolean,
        public estaAutorizado: boolean,
        public funcionalidadeId: number
    ) { }

    marcaDesmarcaAutorizacao(tipoAut: number, valor: boolean) {
        switch (tipoAut) {
            case 0:
                this.podeAcessar = valor;
                break;
            case 1:
                this.podeIncluir = valor;
                break;
            case 2:
                this.podeExcluir = valor;
                break;
            case 3:
                this.podeAlterar = valor;
                break;
            case 4:
                this.podeListar = valor;
                break;
            case 5:
                this.estaAutorizado = valor;
        }
    }

    getAutorizacao(tipoAut: number): boolean {
        switch (tipoAut) {
            case 0:
                return this.podeAcessar;
            case 1:
                return this.podeIncluir;
            case 2:
                return this.podeExcluir;
            case 3:
                return this.podeAlterar;
            case 4:
                return this.podeListar;
            case 5:
                return this.estaAutorizado;
        }
    }

    hasNenhumaAutorizacao(): boolean {
        return  this.podeAcessar === false &&
                this.podeIncluir === false &&
                this.podeExcluir === false &&
                this.podeAlterar === false &&
                this.podeListar === false &&
                this.estaAutorizado === false;
    }
}
